import Div from '@/shared/Div';
import Heading from '@/shared/Heading';
import ProductSizingWidget from '@/shared/crisp/ProductSizingWidget';
import { memo } from 'react';
import VideoCard from '../Static/VideoCard';
import Container from '@/shared/Container';

const SizingAndFitting = (props: any) => {
  const { title, image, video, videoThumbnail } = props;
  if (!image || !video) return null;

  return (
    <Div className="py-s6 md:py-10 text-cm-primary">
      <Container>
        <Heading
          level={2}
          className="text-h-2 md:text-hd-2 md:text-left font-extrabold text-cm-primary"
        >
          {title}
        </Heading>
        <Div className="md:flex gap-s6 mt-s6">
          <ProductSizingWidget image={image} />
          {video && (
            <Div className="flex-1">
              <VideoCard mobileImage={videoThumbnail} desktopImage={videoThumbnail} video={video} />
            </Div>
          )}
        </Div>
      </Container>
    </Div>
  );
};

export default memo(SizingAndFitting);
